import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

import VisibleInApplications from '../visibleInApplications/VisibleInApplications';
import TextField from '@material-ui/core/TextField';

class Settings extends React.Component {
    render() {
        const {
            onNameChange,
            name,
            onApplicationsChange,
            visibleInApplications,
            selectedApplicationsIds,
            classes,
        } = this.props;

        let applicationElement;
        if (onApplicationsChange) {
            applicationElement = (
                <VisibleInApplications
                    visibleInApplications={visibleInApplications}
                    selectedApplicationsIds={selectedApplicationsIds}
                    onChange={onApplicationsChange}
                />
            );
        }

        return (
            <div className={classes.wrapper}>
                <TextField
                    required
                    label="Name"
                    margin="normal"
                    value={name}
                    onChange={onNameChange}
                />
                {applicationElement}
            </div>
        );
    }
}

Settings.propTypes = {
    name: PropTypes.string,
    visibleInApplications: PropTypes.array,
    selectedApplicationsIds: PropTypes.arrayOf(PropTypes.string),
    onNameChange: PropTypes.func.isRequired,
    onApplicationsChange: PropTypes.func,
};

Settings.defaultProps = {
    name: '',
    onApplicationsChange: undefined,
    visibleInApplications: undefined,
    selectedApplicationsIds: undefined,
};

const style = () => ({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
    },
});

export default injectSheet(style)(Settings);



// WEBPACK FOOTER //
// ./src/components/settings/Settings.js